// extracted by mini-css-extract-plugin
export var leftAlign = "_z-2";
export var popper = "_z-0";
export var subtitle = "_z-1";